import { render } from "./RouteView.vue?vue&type=template&id=b04408fa"
import script from "./RouteView.vue?vue&type=script&lang=js"
export * from "./RouteView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\GIT_SPACE\\EnterpriseCloud\\front_iview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__